import React from 'react';
import { Helmet } from 'react-helmet-async';

/**
 * Reusable SEO component.
 * Props: title, description, canonical, image
 */
export default function SEO(props) {
  const {
    title = 'SDC - Software Development Club',
    description = 'Explore student-built software projects, learn, collaborate and innovate at the Software Development Club at MITS-DU.',
    canonical = 'https://sdc.mitsgwalior.in/',
    image = 'https://sdc.mitsgwalior.in/favicon.ico'
  } = props || {};
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonical} />
      {/* Open Graph */}
      <meta property="og:site_name" content="SDC - Software Development Club" />
      <meta property="og:type" content="website" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={image} />
      {/* Twitter */}
      <meta name="twitter:card" content="summary" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
    </Helmet>
  );
}
